/**
 * @author      yontaek@zumper.com (Yon Taek Chung)
 * @copyright   Copyright (c) 2023, Zumper
 * @description PinMarkerContect
 */

import type { NzrListingCardProps } from '@zcode-ui/web-zumper-features'
import type { FiltersState, Listable, Pin, RawPinInventorySearch } from '@zcode/state-type'
import React, { createContext, useContext } from 'react'
import invariant from 'tiny-invariant'

export interface PinMarkerContextType {
  ListingCard: React.FC<NzrListingCardProps>
  openFullDetailTab: ({
    entity,
    filters,
    isSameTab,
    isGalleryURL,
  }: {
    entity: Listable | Pin<RawPinInventorySearch>
    filters: FiltersState
    isSameTab?: boolean
    isGalleryURL?: boolean
  }) => void
  mapRef?: React.RefObject<HTMLDivElement>
}

export const PinMarkerContext = createContext<PinMarkerContextType | null>(null)

export const usePinMarkerContext = () => {
  const context = useContext(PinMarkerContext)
  invariant(context)
  return context
}
